<template>
    <section>
        <div class="row mx-0 px-3 pl-5 my-1 f-600 border-bottom py-2">
            Distancia de los domicilios
        </div>
        <div class="p-3 f-15">
            <div class="row mx-0">
                Crea los diferentes rangos de distancia posibles, para que cada tendero defina los precios de sus domicilios de acuerdo a esa distancia.
            </div>
            <ValidationObserver ref="validacion" v-slot="{ valid }">
                <div class="row mx-0 my-2">
                    <div class="col-2 px-2">
                        <ValidationProvider v-slot="{errors}" rules="required" name="distancia">
                            <p class="ml-2">Distancia (m)</p>
                            <el-input v-model="input1" />
                            <span class="text-danger w-100 f-11"> {{errors[0]}} </span>
                        </ValidationProvider>
                    </div>
                    <div class="col-auto mt-3 pt-1">
                        <el-tooltip class="item" effect="light" content="Crear rango" placement="bottom">
                            <div class="bg-grr-general cr-pointer d-middle-center br-10" style="width:44px;height:44px;">
                                <i class="icon-plus f-20 text-white" />
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </ValidationObserver>
            <div class="row mx-0 my-2">
                Tiendas con domicilios gratis: 12
            </div>
            <div class="row mx-0 my-2">
                Rangos de distancias
            </div>
            <ValidationObserver ref="validacion" v-slot="{ valid }">
                <div v-for="(data, idx) in 4" :key="data" class="row mx-0 my-1">
                    <div class="col-2 px-2">
                        <ValidationProvider v-slot="{errors}" rules="required" name="desde">
                            <el-input :suffix-icon="false?'icon-attention-alt text-danger':''" v-model="input1" :disabled="editar!=idx" />
                            <span class="text-danger w-100 f-11"> {{errors[0]}} </span>
                        </ValidationProvider>
                    </div>
                    <span class="mt-2" :class="false?'oculto':''">A</span>
                    <div class="col-2 px-2" :class="false?'oculto':''">
                        <ValidationProvider v-slot="{errors}" rules="required" name="hasta">
                            <el-input v-model="input1" :disabled="editar!=idx" />
                            <span class="text-danger w-100 f-11"> {{errors[0]}} </span>
                        </ValidationProvider>
                    </div>
                    <div class="col-auto px-1">
                        <el-tooltip v-if="editar!=idx" class="item" effect="light" content="Editar" placement="bottom">
                            <div class="d-middle-center btn-edit pt-1 br-10" style="width:44px;height:44px;">
                                <i class="icon-pencil-outline f-18 cr-pointer" @click="editar=idx" />
                            </div>
                        </el-tooltip>
                        <el-tooltip v-else class="item" effect="light" content="Guardar" placement="bottom">
                            <div class="bg-general2 cr-pointer d-middle-center br-10" style="width:44px;height:44px;" @click="guardar(idx)">
                                <i class="icon-ok-circled-outline text-white f-20" />
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="col-auto px-0">
                        <el-tooltip class="item" effect="light" content="Eliminar" placement="bottom">
                            <div class="d-middle-center btn-delete pt-1 br-10" style="width:44px;height:44px;" @click="eliminar()">
                                <i class="icon-trash-empty f-20 cr-pointer" />
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </ValidationObserver>
            <div class="row mx-0 my-3 justify-content-center">
                <div class="my-4 text-center" style="max-width:170px;">
                    No se ha creado ningún rango de distancia
                </div>
            </div>
        </div>
        <modalEliminar ref="modalEliminar" titulo="Eliminar distancia de domicilia" mensaje="¿Desea eliminar el tipo de tienda?" />
    </section>
</template>

<script>
export default {
    data(){
        return {
            editar: -1,
            options: [{
                value: 'Option1',
                label: 'Option1'
            }, {
                value: 'Option2',
                label: 'Option2'
            }, {
                value: 'Option3',
                label: 'Option3'
            }, {
                value: 'Option4',
                label: 'Option4'
            }, {
                value: 'Option5',
                label: 'Option5'
            }],
            value: 'LA',
            input1: ''
        }
    },
    methods: {
        guardar(idx){
            this.editar=-1
        },
        eliminar(){
            this.$refs.modalEliminar.toggle()
        }
    }
}
</script>

<style lang="css" scoped>
</style>
